"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    formControl: {
      width: '100%'
    },
    option: {
      padding: 16
    }
  };
});

var ProductTypeSelector = function ProductTypeSelector(_ref) {
  var types = _ref.types,
      value = _ref.value,
      onChange = _ref.onChange;
  var classes = useStyles();
  var showDropdown = types.length > 4;
  return /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    className: classes.formControl
  }, showDropdown ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    id: "demo-simple-select-helper-label"
  }, "Product Type"), /*#__PURE__*/_react["default"].createElement(_core.Select, {
    labelId: "demo-simple-select-helper-label",
    id: "demo-simple-select-helper",
    value: value,
    onChange: onChange
  }, types.map(function (_ref2) {
    var key = _ref2.key,
        title = _ref2.title;
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      value: key,
      classes: {
        root: classes.option
      }
    }, key, ": ", title);
  }))) : /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
    "aria-label": "Grant Access",
    name: "acl",
    className: classes.group,
    value: value,
    onChange: onChange
  }, types.map(function (_ref3) {
    var key = _ref3.key,
        title = _ref3.title;
    return /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
      value: key,
      control: /*#__PURE__*/_react["default"].createElement(_core.Radio, null),
      label: title
    });
  })), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, null, "Select Product Type to view data structure"));
};

var _default = ProductTypeSelector;
exports["default"] = _default;